// crm-web/frontend/src/utils/notificationSound.js
let audioContext = null;

export function playNotificationSound() {
  try {
    if (!audioContext) {
      audioContext = new (window.AudioContext || window.webkitAudioContext)();
    }

    const now = audioContext.currentTime;

    // 3-note melody: C5 - E5 - G5 (major chord arpeggio, bright and noticeable)
    const notes = [
      { freq: 523, start: 0,    end: 0.25 },  // C5
      { freq: 659, start: 0.2,  end: 0.45 },  // E5
      { freq: 784, start: 0.4,  end: 0.8  },  // G5 (longer, let it ring)
    ];

    for (const note of notes) {
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      osc.connect(gain);
      gain.connect(audioContext.destination);
      osc.frequency.value = note.freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0, now + note.start);
      gain.gain.linearRampToValueAtTime(0.5, now + note.start + 0.03); // quick attack
      gain.gain.setValueAtTime(0.5, now + note.end - 0.1);
      gain.gain.exponentialRampToValueAtTime(0.01, now + note.end);
      osc.start(now + note.start);
      osc.stop(now + note.end + 0.05);
    }

    // Repeat the melody after a short pause for emphasis
    const repeat = 1.0;
    for (const note of notes) {
      const osc = audioContext.createOscillator();
      const gain = audioContext.createGain();
      osc.connect(gain);
      gain.connect(audioContext.destination);
      osc.frequency.value = note.freq;
      osc.type = 'sine';
      gain.gain.setValueAtTime(0, now + repeat + note.start);
      gain.gain.linearRampToValueAtTime(0.5, now + repeat + note.start + 0.03);
      gain.gain.setValueAtTime(0.5, now + repeat + note.end - 0.1);
      gain.gain.exponentialRampToValueAtTime(0.01, now + repeat + note.end);
      osc.start(now + repeat + note.start);
      osc.stop(now + repeat + note.end + 0.05);
    }
  } catch (err) {
    console.warn('Notification sound failed:', err);
  }
}
